module.exports = __webpack_public_path__ + "img/elcjs.3ba2a5b8.png";